import api_config from '../config/api'

export default {
	async addBanner(form_data, token) {
		return api_config.post('api/banner', form_data, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'multipart/form-data',
			},
		})
	},
	async deleteBanner(banner_id, token) {
		return api_config.delete(`api/banner/${banner_id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
	},
	async getBanners() {
		return api_config.get('api/banner')
	},
	async updateBanner({ id, form_data }, token) {
		return api_config.post(`api/banner/${id}`, form_data, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'multipart/form-data',
			},
		})
	},
}
